import { Component, OnInit } from '@angular/core';
import { CreditCardReportService } from './credit-card-requests.service';
import { Router } from "@angular/router";
import { CustomSelection, Report, RowActions, SelectionAction } from '../../../report/report';
import { ACTIVATION_REQUEST_STATUSES } from '../../../../../shared/services/activationRequestStatuses';
import { SelectionModel } from '@angular/cdk/collections';
import { BulkActivationRequestActionService } from 'src/app/dashboard/seller/my-account/services/bulkActivationRequestAction.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-activation',
  templateUrl: './activation.component.html',
  styleUrls: ['./activation.component.scss']
})

export class ActivationComponent implements OnInit {

  totalNumberOfRecords = 0;
  CreditCardReportData: any[] = [];
  requestBody: Report = {};
  loading = false;
  selectionModel = new SelectionModel<any>(true, []);
  selectionActions: SelectionAction[] = [
    {
      actionName: "Delete",
      actionValue: "DELETE",
      actionType: "Button",
      actionClass: "btn-outline-danger"
    },
    {
      actionName: "Reject",
      actionValue: "REJECT",
      actionType: "Button",
      actionClass: "btn-outline-danger"
    },
    {
      actionName: "Accept",
      actionValue: "ACCEPT",
      actionType: "Button",
      actionClass: "btn-primary"
    }
  ];
  selectableRows: CustomSelection[] = [
    {
      colName: "status",
      valueIn: ["pending","INCOMPLETE","REJECT"]
    }
  ];

  displayTableColumns = {
    'name': 'Bussines Name',
    'status': 'Status',
    'date': 'Date',
    'phone_verified': 'Mobile Verification',
    'mail_verified': 'Email Verification',
    'facebook_verified': 'Facebook Verifcation',
    'businessType': 'Business Registered',
    'facebook_likes': 'Facebook Likes'
  };

  colTypes: any = {
    'phone_verified': 'boolean',
    'mail_verified': 'boolean',
    'facebook_verified': 'boolean',
    'businessType': 'businessType'
  };

  tableColumns = [
    'name',
    'status',
    'date',
    'phone_verified',
    'mail_verified',
    'facebook_verified',
    'businessType',
    'facebook_likes'
  ]

  rowActions: RowActions[] = [{
    actionName: 'View',
    actionType: 'Button',
    actionClass: 'btn-primary',
  }];

  filterField = [
    {
      filterFieldName: "status",
      filterDisplayName: "Activation Request Status",
      defaultValue: ACTIVATION_REQUEST_STATUSES.PENDINGANDCOMPLETE,
      filterOptions: [
        { key: "Show All", value: null },
        { key: ACTIVATION_REQUEST_STATUSES.ACCEPT, value: ACTIVATION_REQUEST_STATUSES.ACCEPT },
        { key: ACTIVATION_REQUEST_STATUSES.REJECT, value: ACTIVATION_REQUEST_STATUSES.REJECT },
        { key: ACTIVATION_REQUEST_STATUSES.PENDING, value: ACTIVATION_REQUEST_STATUSES.PENDING },
        { key: ACTIVATION_REQUEST_STATUSES.INCOMPLETE, value: ACTIVATION_REQUEST_STATUSES.INCOMPLETE },
        { key: ACTIVATION_REQUEST_STATUSES.PENDINGANDCOMPLETE, value: [
            ACTIVATION_REQUEST_STATUSES.PENDING, 
            ACTIVATION_REQUEST_STATUSES.INCOMPLETE
          ]
        }
      ]
    }
  ];

  constructor(
    public withdrawalActivationReportService: CreditCardReportService,
    private bulkRequestsService: BulkActivationRequestActionService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.withdrawalActivationReportService.activateLoader();
    this.requestBody.filterOptions = {
      status: [
        ACTIVATION_REQUEST_STATUSES.PENDING,
        ACTIVATION_REQUEST_STATUSES.INCOMPLETE,
      ],
    };
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };

    this.updateTable();
  }

  actionsCB(event: any) {
    this.router.navigate([`/seller/settings/requestActivation/${event.key.id}`]);
  }

  async selectionActionCB(event) {
    let validRequests = []
    let requests = event.selection
    for(let request of requests){
      if (
        request.facebook_verified &&
        request.mail_verified &&
        request.phone_verified
      ) {
        validRequests.push(request);
      }
    }
    if(validRequests.length < requests.length && event.action == 'ACCEPT'){
      Swal.fire({
        icon: 'warning',
        text: `Only ${validRequests.length} of ${requests.length} selected requests 
              have valid facebook, email and password. Please select valid requests
              and try again`
      })
      return
    }
    this.bulkRequestsService.setParams({
      status: event.action,
      requests
    })
    let result = await this.bulkRequestsService.make()
    if(result.success){
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Activation requests are successfully updated',
        timer: 3000
      })
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Ooops',
        text: 'Something went wrong, please try again',
        timer: 3000
      })
    }
    this.updateTable();
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.withdrawalActivationReportService.loader().subscribe(val => (this.loading = val));
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.withdrawalActivationReportService.loader().subscribe(val => (this.loading = val));
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.withdrawalActivationReportService.loader().subscribe(val => (this.loading = val));
  }

  async updateTable() {
    this.withdrawalActivationReportService.activateLoader();
    this.withdrawalActivationReportService.setParams(this.requestBody);
    const report = await this.withdrawalActivationReportService.make();
    this.CreditCardReportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  async searchChange(event: any) {
    console.log(event)
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.withdrawalActivationReportService.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }
}

